import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerContactEventPayload } from '../models/customer-contact-event-payload';

@Injectable()
export class CustomerContactService {
  private customerContactSubject: BehaviorSubject<CustomerContactEventPayload> = new BehaviorSubject<CustomerContactEventPayload>(null);
  private customerContactChangedObservable: Observable<CustomerContactEventPayload> = this.customerContactSubject.asObservable();

  public setCustomerContact(customerContactChangedPayload: CustomerContactEventPayload): void {
    this.customerContactSubject.next(customerContactChangedPayload);
  }

  public getCustomerContact(): CustomerContactEventPayload {
    return this.customerContactSubject.getValue();
  }

  public customerContactChanged(): Observable<CustomerContactEventPayload> {
    return this.customerContactChangedObservable;
  }
}
